/*!
=========================================================
* 支払依頼（その他）登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card,  CardHeader,  CardTitle,
  Table,  Row,  Col, Container,
  Modal, ModalBody, ModalFooter,
  FormGroup,
} from "reactstrap";
import ReactTable from "react-table-legacy";
import ButtonWithTooltip from '../../FormParts/ButtonWithTooltip';
import InputText from '../../FormParts/InputText'
import InputNumber from '../../FormParts/InputNumber'
import InputSelect from '../../FormParts/InputSelect'
import InputRadio from '../../FormParts/InputRadio'
import InputDatetime from '../../FormParts/InputDatetime'
import Request from '../../../common/Request';
import Format from '../../../common/Format';
import CustomTd from '../../ViewParts/CustomTd';
import _ from 'underscore';
import {
  cst_payment_type,
  cst_payment_bank_account_type
} from '../../../variables/codes_map';
import Definition from '../../../common/Definition'
import GsuiteAuth from '../../../components/Auth/GsuiteAuth'
import WithRole from '../../FormParts/ButtonWithRole';
import FormatCode from '../../../common/FormatCode';

var domain = "";  

class List extends React.Component {

  constructor(props){
    super(props);
    this.state ={
        paymentEditIndex: undefined,
        bankBranchList:[],
        bankList:[],
        regist_modal: false,
        sub_regist_modal: false,
        error_modal: false,
        view: false,
        pdata:[],
        sdata:{},
        error:true,
        paymentData:{
          values:{
            payment_bank: "",
            payment_bank_branch: "",
            payment_bank_account_kana: "",
            payment_bank_account_type: "",
            payment_bank_account_number: "",
            payment_amt: 0,
            payment_type : cst_payment_type[0].default
          },
          errors:{},
          requiredData:{}
        },
        data:{
          values:{},
          errors:{},
          requiredData:{},
        },
        request_data:{}
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.toggleSubRegistModal = this.toggleSubRegistModal.bind(this);
    this.summationSelected = this.summationSelected.bind(this);
    this.summationRemove = this.summationRemove.bind(this);
    this.paymentSelected = this.paymentSelected.bind(this);
    this.paymentRemove = this.paymentRemove.bind(this);
    this.summation_select_popup = React.createRef();
    this.validateCallback = this.validateCallback.bind(this)
    this.summation_list = this.summation_list.bind(this)
    this.payment_list = this.payment_list.bind(this)
    this.regist = this.regist.bind(this)
    this.paymentEdit = this.paymentEdit.bind(this)
  } 

      // 初期ロード用
  componentDidMount(){
    /*　ここは開発者が記述　*/
    if (this.props.match.params.request_natural_id != undefined ) {
      const paymentUrl = '/api/payment'
      const paymentPatams = {
        estimate_natural_id_ssv: this.props.match.params.request_natural_id,
        payment_status:["0","1","2","3","4","5"]
      }
      Request.get(paymentUrl, paymentPatams,
        async paymentResponse => {
          const paymentData = paymentResponse.Data
          
          const url = domain + '/api/requestpayment/other';
          const params = {
            request_natural_id: this.props.match.params.request_natural_id
          }; 
          Request.get(url, params,
            res => {
              if(res.Data.length > 0){
                const request_natural_id =　(this.props.match.params.request_natural_id)

                if(res.Data[0].payment_request_status == 1 || res.Data[0].payment_request_status == 5 ){
                  this.props.pageChangeAlert.current.inactivate();
                  this.props.alertModal.current.confirmCheck({
                    messageNo:2446
                  },()=>this.props.history.push('/construction/list'),false)
                }

                Request.get('/api/request/other', {
                  request_natural_id,
                  all_survey_status:true
                }, requestRes=>{
                  this.setState({
                    sdata:{[res.Data[0].ulid]:res.Data[0]},
                    request_data:requestRes.Data[0],
                    view:paymentData.length>0?true:false,
                    pdata:paymentData,
                  });
                })
              } else {
                this.props.pageChangeAlert.current.inactivate();
                this.props.history.push('/forbidden')
                return
              }
            });
        
        }
      )
    }
    Request.get('/api/bank', {}, res=>{
      this.setState({
        bankList:res.Data.map(element=>{
          return {
            value:element.bank_natural_id,
            label:element.bank_name
          }
        })
      });
    })
    Request.get('/api/bank/branch', {}, res=>{
      this.setState({
        bankBranchList:res.Data.map(element=>{
          return {
            value:element.bank_branch_natural_id,
            label:element.bank_branch_name,
            bank_natural_id:element.bank_natural_id
          }
        })
      });
    })
  }

  summationSelected(estimate) {
    if (estimate) {
      this.setState({
        sdata: {
          ...this.state.sdata,
          [estimate.ulid]:estimate
        }
      });
    }
  }

  summationRemove(key){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      this.setState({
        sdata: Object.keys(this.state.sdata).reduce((acc,keyName)=>{
            if (key!==keyName) {
              acc[keyName] = this.state.sdata[keyName]
            }
            return acc
          },{})
      });
    })
  }

  validateCallback(newData, callback=()=>{}){
    const {
      bank_branch_natural_id: new_bank_branch_natural_id,
      bank_natural_id: new_bank_natural_id,
      payment_bank_account_kana
    } = newData.values
    const didBankChanged = newData.values.bank_natural_id != this.state.paymentData.values.bank_natural_id

    const bank = this.state.bankList.find((element)=>element.value==new_bank_natural_id)
    const payment_bank = bank ? bank.label : new_bank_natural_id
    const bank_branch = didBankChanged ? null : (this.state.bankBranchList.find((element)=> (bank && bank.value == element.bank_natural_id && element.value==new_bank_branch_natural_id)))
    const payment_bank_branch = didBankChanged ? null : (bank_branch ? bank_branch.label : new_bank_branch_natural_id)
    const bank_natural_id = new_bank_natural_id
    const bank_branch_natural_id = didBankChanged ? null : new_bank_branch_natural_id

    this.setState({
      paymentData:{
        ...this.state.paymentData,
        ...newData,
        values:{
          ...newData.values,
          payment_bank_account_kana : null
        }
      }
    }, ()=>this.setState({
      paymentData:{
        ...this.state.paymentData,
        values:{
          ...newData.values,
          bank_branch_natural_id,
          bank_natural_id,
          payment_bank_branch,
          payment_bank,
          payment_bank_account_kana : payment_bank_account_kana
        }
      }
    }))
  }

  paymentSelected() {
    if (Object.keys(this.state.paymentData.errors).length===0){
      const {
        paymentEditIndex,
        pdata,
      } = this.state
      let { values } = this.state.paymentData;

      if(values.payment_type != "0"){
        values = {
          ...values,
          bank_natural_id: null,
          bank_branch_natural_id: null,
          payment_bank: null,
          payment_bank_branch: null,
          payment_bank_account_kana: null,
          payment_bank_account_type: null,
          payment_bank_account_number: null,
        }
      }
      values.bank_natural_id = values.bank_natural_id === values.payment_bank? undefined : values.bank_natural_id
      values.bank_branch_natural_id = values.bank_branch_natural_id === values.payment_bank_branch? undefined : values.bank_branch_natural_id
      this.setState({
        ...(
          paymentEditIndex===undefined
          ? {pdata: [...pdata, values]}
          : {pdata: [...pdata.map((payment, index)=>{
            return paymentEditIndex!==index?payment:values
          })]}
        ),
        paymentData:{
          values:{
            payment_bank: "",
            payment_bank_branch: "",
            payment_bank_account_kana: "",
            payment_bank_account_type: "",
            payment_bank_account_number: "",
            payment_type: "0",
            payment_amt: 0
          },
          errors:{},
          requiredData:this.state.paymentData.requiredData
        },
        paymentEditIndex:paymentEditIndex!==undefined?undefined:paymentEditIndex
      });
    } else {
      this.props.alertModal.current.showErrorModal({messageNo:2401})
    }
  }

  paymentRemove(key){
    this.props.alertModal.current.confirmCheck({messageNo:2411},()=>{
      if(key !== undefined){
        this.setState({
          pdata: this.state.pdata.filter((payment, index)=>key!==index)
        });
      }
    })
  }

  toggleRegistModal(reset=false) {
    if (reset) {
      this.setState({
        regist_modal: !this.state.regist_modal,
        paymentEditIndex : undefined,
        paymentData:{
          values:{
            payment_bank: "",
            payment_bank_branch: "",
            payment_bank_account_kana: "",
            payment_bank_account_type: "",
            payment_bank_account_number: "",
            payment_amt: 0,
            payment_type : cst_payment_type[0].default,
            payment_user_memo: Object.keys(this.state.sdata).length>0 && this.state.sdata[Object.keys(this.state.sdata)[0]].order_memo
          },
          errors:{},
          requiredData:{}
        },
      });
    } else {
      this.setState({
        regist_modal: !this.state.regist_modal,
      })
    }
  }

  toggleSubRegistModal(){
    if(this.props.match.params.construction_id != undefined){
      return null;
    }else{
      this.setState({
        sub_regist_modal: !this.state.sub_regist_modal
      });
    }
  }
  
  regist() {
    const estimate_natural_id_ssv = Object.keys(this.state.sdata).map((estimateUlid)=>this.state.sdata[estimateUlid].estimate_natural_id).join(',')
    const estimates = Object.keys(this.state.sdata).map((estimateUlid)=>{
      return {
        estimate_natural_id: this.state.sdata[estimateUlid].estimate_natural_id,
        update_timestamp: this.state.sdata[estimateUlid].update_timestamp
      }
    })
    const {
      user_branch_id,
      user_branch_natural_id
    } = this.state.sdata[Object.keys(this.state.sdata)[0]]
    const params = this.state.pdata.map((payment)=>{
      return {
        ...payment,
        estimate_natural_id_ssv,
        user_branch_id, //GsuiteAuth.get('user_branch_id'),
        user_branch_natural_id, //GsuiteAuth.get('user_branch_natural_id'),
        estimates
      }
    })
    const total_payment_amt = this.state.pdata.reduce((acc, singleData)=>{
      acc += isNaN(Number(singleData['payment_amt']))?0:Number(singleData['payment_amt'])
      return acc
    }, 0)

    if (this.state.view) {
      // put update
      Request.put('/api/requestpayment/other/update', {estimates : estimates, payments : params, total_payment_amt : total_payment_amt}, res => {
        if (res.Code==200){
          this.props.pageChangeAlert.current.inactivate();
          this.toggleSubRegistModal();
          this.props.history.push("/requestpayment/other");  
        }
      });
    } else {
      // post regist
      Request.post('/api/requestpayment/other', {estimates : estimates, payments : params, total_payment_amt : total_payment_amt}, res => {
        if (res.Code==200){
          this.props.pageChangeAlert.current.inactivate();
          this.toggleSubRegistModal();
          this.props.history.push("/requestpayment/other");  
        }
      });
    }    
  }

  summation_list({data = {}, index, keyName}){
    const {
      quote_cost_total_amt,
      site_name,
      construction_number,
      request_natural_id,
      supplier_ulid
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    const supplier_bank_url = "/supplier/detail/" + supplier_ulid    
    return (
      <>
      <tr className="table-link" key={index}>
        <td style={align}>{request_natural_id}</td>
        <td style={align}>{site_name}</td>
        <td style={align}>{construction_number}</td>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', data)}} /></td>
        <td style={align}><span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_request_other_qty', data)}} /></td>
        <td style={align}>{Format.comma_delimited(quote_cost_total_amt,"円")}</td>
        <td>
            <button disabled={index == 0 || this.state.view} type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.summationRemove(keyName)}}>
            削除
            </button>
        </td>
      </tr>                            
      </>
    );
  }

  payment_list({data={},index}){
    const {
      payment_bank_account_kana,
      payment_type,
      payment_amt,
      id,
      payment_status,
      payment_limit_date,
      payment_request_memo      
    } = data
    const align={
      verticalAlign: "top",
      textAlign: "left"
    }
    return (
      <tr key={index}>
        <td  style={align}>
          <span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_bank_name', data)}} /><br />
          <span dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_payment_bank_detail', data)}} /><br />
          {payment_bank_account_kana}
        </td>
        <td style={align}>{FormatCode.decode("cst_payment_type", payment_type)}</td>
        <td style={align}>{Format.format_date(payment_limit_date)}</td>
        <td style={align}>{Format.comma_delimited(payment_amt,"円")}</td>
        <td style={align}>{payment_status===undefined ? "新規" : FormatCode.decode("cst_payment_status", payment_status)}</td>
        <td style={align}>{payment_request_memo}</td>
        <td>
          <button disabled={payment_status === undefined ? false : payment_status != "2"} type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.paymentEdit(index)}}>
          編集
          </button>
          <button disabled={this.state.view && id} type="button" className="btn btn-sm" data-dismiss="modal" aria-label="Close" onClick={() => {this.paymentRemove(index)}}>
          削除
          </button>
        </td>
      </tr>
    );
  }

  paymentEdit(index){
    this.setState({
      paymentEditIndex:index,
      paymentData:{
        values:{
          ...this.state.paymentData.values,
          ...this.state.pdata[index],
          bank_natural_id : this.state.pdata[index].bank_natural_id || this.state.pdata[index].payment_bank,
          bank_branch_natural_id : this.state.pdata[index].bank_branch_natural_id || this.state.pdata[index].payment_bank_branch
        },
        errors:{}
      },
      regist_modal: !this.state.regist_modal
    });
  }

  render() {
    const SummationList = this.summation_list
    const PaymentList = this.payment_list
    const ___SUM_payment_amt = Definition.item('___SUM_payment_amt', this.state.pdata)
    const ___SUM_other_total_amt = Definition.item('___SUM_other_total_amt', Object.keys(this.state.sdata).map(keyName=>this.state.sdata[keyName]))
    const ButtonWithRole = WithRole(Button, this.props.buttons, this.state.request_data)
    const selectableBankBranch = this.state.bankBranchList.filter(element=>element.bank_natural_id==this.state.paymentData.values.bank_natural_id)
    console.log('state', this.state)
    return (
      <>
        <div className="content">
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h3" className="float-left">{`仕入依頼（その他）${this.state.view?"更新":"登録"}`}</CardTitle>
              </CardHeader>
              <Col md="11"  className="detail">
                <Table>
                  <tbody>
                    <tr>
                      <th>仕入対象見積合計</th>
                      <th className="sub">支払合計</th>
                    </tr>
                    <tr>
                      <td>
                        {Format.comma_delimited(___SUM_other_total_amt,"円")}
                      </td>
                      <td>
                        {Format.comma_delimited(___SUM_payment_amt,"円")}
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left">仕入対象見積</CardTitle>
                  </Col>
                  {/* <Col md="6">
                  {
                    this.state.view
                    ? ""
                    :(
                      <ButtonWithTooltip onclick={() => { this.summation_select_popup.current.show(); }} class="btn-search btn-facebook float-right" id="tmp" icon="fas fa-plus" label="追加" message="仕入対象見積情報を追加します。" />
                    )
                  }
                  </Col> */}
                </Row>
                <Row>
                <Col md="12" className="detail-table-wrapper">
                  <Table>
                    <tbody>
                      <tr>
                          <th>案件ID</th>
                          <th>現場名</th>
                          <th>工事番号</th>
                          <th>顧客情報</th>
                          <th>仕入情報</th>
                          <th>仕入値</th>
                          <th>削除</th>
                      </tr>
                      {Object.keys(this.state.sdata).length>0 && Object.keys(this.state.sdata).map((keyName,index)=> {
                        const data = this.state.sdata[keyName]
                        return <SummationList data={data} index={index} key={index} keyName={keyName}/>
                      })}
                      
                    </tbody>
                  </Table>
                </Col>
                </Row>
                <Row>
                  <Col md="6">
                      <CardTitle tag="h4" className="float-left sub">支払先情報</CardTitle>
                  </Col>
                  <Col md="6">
                      <ButtonWithTooltip onclick={() => { this.toggleRegistModal(true); }} class="btn-search btn-facebook float-right" id="tmp" icon="fas fa-plus" label="追加" message="支払先情報を追加します。" />
                  </Col>
                </Row>
                <Row>
                <Col md="12" className="detail-table-wrapper">
                  <Table>
                    <thead>
                      <tr>
                        <th className="sub">口座情報</th>
                        <th className="sub">支払方法</th>
                        <th className="sub">支払期日</th>
                        <th className="sub">支払額</th>
                        <th className="sub">仕入状況</th>
                        <th className="sub">メモ</th>
                        <th className="sub">削除</th>
                      </tr>
                    </thead>
                    <tbody>
                    {this.state.pdata.length>0 && this.state.pdata.map((data,index)=> {
                      return <PaymentList data={data} index={index} key={index}/>
                    })}
                    </tbody>
                  </Table>
                </Col>
                </Row>
                <Container>
                  <Row>
                    <Col md="6">
                    </Col>
                    {/* <Col md="6" className={___SUM_other_total_amt===___SUM_payment_amt?"off":"on"}>
                      <span className="red">※合算額合計と、支払額の合計が一致しません</span>
                    </Col> */}
                  </Row>
                  <Row>
                    <Col md="6" className="text-center">
                      <Button color="secondary" onClick={() => { this.props.history.push("/requestpayment/other") }}>一覧に戻る</Button>
                    </Col>
                    <Col md="6" className="text-center">
                      <ButtonWithRole
                        button_id="BTN_FX_02_02980"
                        color="secondary info"
                        onClick={() => {this.toggleSubRegistModal();}}
                      >
                        仕入依頼
                      </ButtonWithRole>
                    </Col>
                  </Row>
                </Container>
              </Col>
            </Card>
          </Col>
        </div>
        <EstimateSelectPopup ref={this.summation_select_popup} summationSelectedCallback={this.summationSelected} sdata={this.state.sdata}/>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">支払先情報</h5>
          </div>
          <ModalBody>
            <Row className="detail">
              <Col md="12" className="text-center">
                <Table>
                  <tbody>
                    <tr>
                      {/* <th rowSpan="7">支払情報</th> */}
                      <CustomTd label='銀行名'
                          name='PAYMENT__bank_natural_id'
                          copy={false}
                          rootData={this.state.paymentData}
                          value={
                            <InputSelect
                              disabled={this.state.paymentData.values.payment_type != "0"}
                              options={this.state.bankList}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              isSearchable={true}
                              isCreatable={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='支店名'
                          name='PAYMENT__bank_branch_natural_id'
                          copy={false}
                          rootData={this.state.paymentData}
                          value={
                            <InputSelect
                              disabled={this.state.paymentData.values.payment_type != "0"}
                              options={selectableBankBranch}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                              isSearchable={true}
                              isCreatable={false}
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座名義（カナ）'
                          name='PAYMENT__payment_bank_account_kana'
                          copy={false}
                          rootData={this.state.paymentData}
                          value={
                            <InputText
                              disabled={this.state.paymentData.values.payment_type != "0"}
                              validateCallback={this.validateCallback} 
                              validateType='regist'
                            />
                          }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座種別'
                        name='PAYMENT__payment_bank_account_type'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputSelect
                            disabled={this.state.paymentData.values.payment_type != "0"}
                            options={cst_payment_bank_account_type}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                            isSearchable={true}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='口座番号'
                        name='PAYMENT__payment_bank_account_number'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputText
                            disabled={this.state.paymentData.values.payment_type != "0"}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='支払方法（今回）'
                        name='PAYMENT__payment_type'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputRadio
                            options={cst_payment_type}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='支払期日'
                        name='PAYMENT__payment_limit_date'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputDatetime
                          labelOn={false}
                          validateCallback={this.validateCallback}
                          validateType={'regist'}
                          timeFormat={false}
                        />
                        }
                      />
                    </tr>                    
                    <tr>
                      <CustomTd label='支払額（今回）'
                        name='PAYMENT__payment_amt'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputNumber
                            unit='円' 
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                            size={12}
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='仕入依頼時のメモ'
                        name='PAYMENT__payment_request_memo'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputText multiline={true}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                    <tr>
                      <CustomTd label='経理課への仕入メモ（仕入依頼時に入力）'
                        name='PAYMENT__payment_user_memo'
                        copy={false}
                        rootData={this.state.paymentData}
                        value={
                          <InputText multiline={true}
                            validateCallback={this.validateCallback} 
                            validateType='regist'
                          />
                        }
                      />
                    </tr>
                  </tbody>
                </Table>
            </Col>
            <Col md="12" className="text-center">
             <Button color="info" 
                onClick={() => {
                  this.paymentSelected();
                  this.toggleRegistModal();
                }} className="float-right">支払先追加</Button>
            </Col>
          </Row>
          </ModalBody>
          <ModalFooter>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.sub_regist_modal} toggle={this.toggleSubRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleSubRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">仕入依頼</h5>
          </div>
          <ModalBody>
            <p>仕入依頼をします。よろしいですか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleSubRegistModal}>
              いいえ
            </Button>
            <Button color="info" onClick={()=>{this.regist()}}>
              はい
            </Button>
          </ModalFooter>
        </Modal> 
      </>
    );
  }
}

class EstimateSelectPopup extends React.Component {
  default_column = [
      { Header: '案件ID', accessor: 'request_natural_id', headerClassName: "text-center", className: "text-center" ,defaultView:true},
      { Header: '顧客情報', accessor: '___JOIN_client_master', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
      { Header: '顧客情報（下請）', accessor: '___JOIN_subcontract_customer_information', headerClassName: "text-center", className: "text-left text-top" ,defaultView:true},
      { Header: '契約期間', accessor: '___JOIN_quote_available_date', headerClassName: "text-center", className: "text-center" ,defaultView:true},
      { Header: '仕入情報', accessor: '___JOIN_quote_use_parking', headerClassName: "text-center", className: "text-center" ,defaultView:true},
      { Header: 'アクション', accessor: 'action', headerClassName: "text-center", className: "text-center" },
  ];
  constructor(props) {
      super(props);

      this.state = {
          modal: false,
          data: [],
          column: this.default_column,
          searchData:{
              values:{},
              errors:{},
              requiredData:{}
          }
      };

      this.toggleModal = this.toggleModal.bind(this);
      this.search = this.search.bind(this);
      this.clickSelectButton = this.clickSelectButton.bind(this);
      this.validate = this.validate.bind(this)
      this.validateCallback = this.validateCallback.bind(this)
  }

  search_params() {
      const {values} = this.state.searchData
          return values&&Object.keys(values).reduce((acc, key)=>{
              if (values[key]){
                  acc[key] = values[key]
              }
          return acc
      },{})
    }
  
  search() {
  /* ここは開発者が記述 */
      if (!this.validate()) {
          // do nothing
          return;
      }
      Request.get('/api/requestpayment/other', 
          this.search_params()
          , res => {
            const selectedList = Object.keys(this.props.sdata).map(keyName=>this.props.sdata[keyName])
            const filterdData = res.Data.filter(mapData => {
                return !(selectedList.some(selectedData => selectedData.request_natural_id === mapData.request_natural_id))
            })
            this.setState({
                data: this.dataMap(filterdData)
            });
      })
  }

  validate() {
      return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
      this.setState({
          searchData:{
          ...this.state.searchData,
          ...newData
          }
      }, ()=>callback())
  }

  dataMap(data) {
      return data.map((prop, key) => {
          return {
              id: key,
              request_natural_id: prop.request_natural_id,
              ___JOIN_client_master: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_client_master', prop)}} />,
              ___JOIN_subcontract_customer_information: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_subcontract_customer_information', prop)}} />,
              ___JOIN_quote_available_date: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_available_date', prop)}} />,
              ___JOIN_quote_use_parking: <div dangerouslySetInnerHTML={{__html:Definition.item('___JOIN_quote_use_parking', prop)}} />,
              action: (<Button type="button" color="default" className="btn-sm" onClick={() => { this.clickSelectButton(prop); }}>追加</Button>)
          }
      });
  }

  clickSelectButton(prop) {
      if (this.props.summationSelectedCallback) {
          this.props.summationSelectedCallback(prop);
      }
      this.setState({ data : [] })
      this.toggleModal();
  }

  show() {
      this.setState({ modal: true });
  }

  toggleModal() {
      this.setState({
          modal: !this.state.modal
      });
  }

  render() {
      return (
          <Modal size="xlg" isOpen={this.state.modal}>
              <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleModal}>
                      <i className="tim-icons icon-simple-remove"></i>
                  </button>
                  <span style={{width: "100%"}}>
                      <h5 className="modal-title float-left">案件検索</h5>
                  </span>
              </div>
              <ModalBody>
                  <Row>
                      <Col md="6">
                          <FormGroup>
                              <InputText
                                  label='案件ID'
                                  name='REQUEST__request_natural_id'
                                  labelOn={true}
                                  validateCallback={this.validateCallback}
                                  enterCallback={this.search}
                                  enterSearchFlag={true}
                                  rootData={this.state.searchData}
                                  validateType={'search'}
                                  />
                          </FormGroup>
                          <Button onClick={this.search}>検索</Button>
                      </Col>
                  </Row>
                  <Row>
                      <ReactTable
                          style={{ width: '100%' }}
                          data={this.state.data}
                          columns={this.state.column}
                          defaultPageSize={5}
                          filterable={false}
                          showPageSizeOptions={false}
                          showPaginationTop={true}
                          showPaginationBottom={true}
                          previousText="前へ"
                          nextText="次へ"
                          rowsText="件表示"
                          loadingText='読込中…'
                          noDataText='データが有りません。'
                          pageText=''
                          ofText='/'
                          className="-highlight primary-pagination"
                      />
                  </Row>
              </ModalBody>
              <ModalFooter>
              </ModalFooter>
          </Modal>
      );
  }
}
export default List;
